import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { SecondaryButton, TransparentBgButton } from 'components/Shared/Button'
import { getGoogleAdsDashboardUrl } from './testCampaignUtils'

export default function GoogleSuccessView({ campaign, onClose, onRunAnother }) {
  const { t } = useTranslation()

  const dashboardUrl = getGoogleAdsDashboardUrl(campaign.ad_account_id)

  return (
    <div className="test-campaign-success">
      <div className="test-campaign-success__content">
        <div className="test-campaign-success__header">
          <h3>
            {t(
              'Settings.GoogleAccess.TestCampaign.successTitle',
              'Test Campaign Created Successfully!',
            )}
          </h3>
        </div>

        {(campaign.campaign_name || campaign.campaign_id) && (
          <div className="test-campaign-success__detail">
            <label className="mb-0">
              {t('Settings.GoogleAccess.TestCampaign.campaignDetails', 'Campaign Details')}
            </label>
            <div className="test-campaign-success__detail-value">
              {campaign.campaign_name && <span>{campaign.campaign_name}</span>}
              {campaign.campaign_name && campaign.campaign_id && (
                <span className="separator"> • </span>
              )}
              {campaign.campaign_id && <span className="campaign-id">{campaign.campaign_id}</span>}
            </div>
          </div>
        )}

        {campaign.assets?.conversion_action_id && (
          <div className="test-campaign-success__assets">
            <label>{t('Settings.GoogleAccess.TestCampaign.assetsUsed', 'Assets Used')}</label>
            <div className="test-campaign-success__assets-list">
              <div className="test-campaign-success__asset-item">
                <span className="asset-label">
                  {t('Settings.GoogleAccess.TestCampaign.adAccount', 'Ad Account')}:
                </span>
                <span className="asset-value">{campaign.ad_account_id}</span>
              </div>
              <div className="test-campaign-success__asset-item">
                <span className="asset-label">
                  {t('Settings.GoogleAccess.TestCampaign.conversionAction', 'Conversion Action')}:
                </span>
                <span className="asset-value">{campaign.assets.conversion_action_id}</span>
              </div>
            </div>
          </div>
        )}

        <div className="test-campaign-success__info">
          <span className="test-campaign-success__info-text text-left">
            {t(
              'Settings.GoogleAccess.TestCampaign.successNote',
              'Your Display campaign is paused in Google Ads. View it in your dashboard to confirm everything looks correct.',
            )}
          </span>
        </div>

        <a
          href={dashboardUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="d-block mt-3"
          style={{ color: '#2F80ED', textDecoration: 'underline' }}
        >
          {t('Settings.GoogleAccess.TestCampaign.viewDashboard', 'View in Google Ads Dashboard →')}
        </a>
      </div>

      <div className="test-campaign-success__footer">
        <div className="d-flex gap-2 w-100 justify-content-between">
          <TransparentBgButton
            text={t('common.close', 'Close')}
            onClick={onClose}
            color="navy"
            fullWidth
            extraStyles={{ flex: 1 }}
          />
          <SecondaryButton
            className="bt"
            text={t('Settings.GoogleAccess.TestCampaign.runAnother', 'Run Another')}
            fullWidth
            onClick={onRunAnother}
            extraStyles={{ flex: 1 }}
          />
        </div>
      </div>
    </div>
  )
}

GoogleSuccessView.propTypes = {
  campaign: PropTypes.shape({
    campaign_id: PropTypes.string,
    campaign_name: PropTypes.string,
    ad_account_id: PropTypes.string.isRequired,
    assets: PropTypes.shape({
      conversion_action_id: PropTypes.string,
    }),
  }).isRequired,
  onClose: PropTypes.func.isRequired,
  onRunAnother: PropTypes.func.isRequired,
}
